export const TOP_LEVEL_CATEGORIES = ["Bathroom", "Kitchen", "Tiles", "Lighting", "Electricity", "Hardware", "Accessories", "Life Style"] as const;

export type TopLevelCategory = (typeof TOP_LEVEL_CATEGORIES)[number];

type ProductCategoryInput = {
  title?: string;
  productType?: string;
  tags?: string[] | string;
  vendor?: string;
};

const normalizeValue = (value: string) => value.toLowerCase().trim().replace(/\s+/g, " ");

const PRODUCT_TYPE_TO_CATEGORY: Record<string, TopLevelCategory> = {
  // Lighting
  [normalizeValue("Chandeliers")]: "Lighting",
  [normalizeValue("Ceiling Lights")]: "Lighting",
  [normalizeValue("Wall lights")]: "Lighting",
  [normalizeValue("Wall Lights")]: "Lighting",
  [normalizeValue("Pendant Lights")]: "Lighting",
  [normalizeValue("Spot lights")]: "Lighting",
  [normalizeValue("Spot Lights")]: "Lighting",
  [normalizeValue("Outdoor Lighting")]: "Lighting",
  [normalizeValue("Light Bulbs")]: "Lighting",
  [normalizeValue("Light shades")]: "Lighting",
  [normalizeValue("Light Shades")]: "Lighting",
  [normalizeValue("Pendants")]: "Lighting",
  [normalizeValue("Table Lamps")]: "Lighting",
  [normalizeValue("Table Lamp")]: "Lighting",
  [normalizeValue("Floor Lamps")]: "Lighting",

  // Electricity
  [normalizeValue("Light switches")]: "Electricity",
  [normalizeValue("Light Switches")]: "Electricity",
  [normalizeValue("Dimmer Switches")]: "Electricity",
  [normalizeValue("Dimmer Sets")]: "Electricity",
  [normalizeValue("Plug sockets")]: "Electricity",
  [normalizeValue("Plug & Sockets")]: "Electricity",
  [normalizeValue("Sockets")]: "Electricity",
  [normalizeValue("Back Boxes")]: "Electricity",
  [normalizeValue("Plates")]: "Electricity",
  [normalizeValue("Modules")]: "Electricity",
  [normalizeValue("Other switches")]: "Electricity",
  [normalizeValue("Toggle Switches")]: "Electricity",
  [normalizeValue("Rocker Switches")]: "Electricity",
  [normalizeValue("UK Products")]: "Electricity",
  [normalizeValue("Switch Sets")]: "Electricity",
  [normalizeValue("Switch and socket frames")]: "Electricity",
  [normalizeValue("Detail Kit")]: "Electricity",

  // Hardware
  [normalizeValue("Door Handle")]: "Hardware",
  [normalizeValue("Door Handles")]: "Hardware",
  [normalizeValue("Fixed Door Handle")]: "Hardware",
  [normalizeValue("Door Knob")]: "Hardware",
  [normalizeValue("Door Knobs")]: "Hardware",
  [normalizeValue("Fixed Door Knob")]: "Hardware",
  [normalizeValue("Door Hinge")]: "Hardware",
  [normalizeValue("Door Locks")]: "Hardware",
  [normalizeValue("Door locks")]: "Hardware",
  [normalizeValue("Escutcheon Plates")]: "Hardware",
  [normalizeValue("Door Stop")]: "Hardware",
  [normalizeValue("Closet Bar")]: "Hardware",
  [normalizeValue("Deadbolt Latch")]: "Hardware",
  [normalizeValue("Mirror")]: "Hardware",
  [normalizeValue("Spares")]: "Hardware",
  [normalizeValue("Cabinet Knobs")]: "Hardware",
  [normalizeValue("Cabinet Handles")]: "Hardware",
  [normalizeValue("Pull Bars")]: "Hardware",
  [normalizeValue("T-Bar")]: "Hardware",
  [normalizeValue("Fittings Kit")]: "Hardware",

  // Accessories
  [normalizeValue("Jewellery")]: "Accessories",
  [normalizeValue("Pets")]: "Accessories",
  [normalizeValue("Pet Products")]: "Accessories",
  [normalizeValue("Preces mājdzīvniekiem")]: "Accessories",
  [normalizeValue("Machined")]: "Accessories",
  [normalizeValue("Gifts")]: "Accessories",

  // Kitchen
  [normalizeValue("Cookware")]: "Kitchen",
  [normalizeValue("Mixer Faucets")]: "Kitchen",
  [normalizeValue("Kitchen Faucets")]: "Kitchen",
  [normalizeValue("Kitchen Girder Shelf")]: "Kitchen",
  [normalizeValue("Kitchen Hanger Shelf")]: "Kitchen",
  [normalizeValue("Frying Pans")]: "Kitchen",
  [normalizeValue("Pots")]: "Kitchen",
  [normalizeValue("Sinks")]: "Kitchen",
  [normalizeValue("Granite Sinks")]: "Kitchen",
  [normalizeValue("Steel Sinks")]: "Kitchen",
  [normalizeValue("Ceramic Sinks")]: "Kitchen",
  [normalizeValue("Soap Dispensers")]: "Kitchen",
  [normalizeValue("Drainers")]: "Kitchen",
  [normalizeValue("Baskets")]: "Kitchen",
  [normalizeValue("Cutting Boards")]: "Kitchen",
  [normalizeValue("Kitchen Accessories")]: "Kitchen",
  [normalizeValue("Kitchen")]: "Kitchen",

  // Bathroom
  [normalizeValue("Bathroom")]: "Bathroom",
  [normalizeValue("Bathroom Faucets")]: "Bathroom",
  [normalizeValue("Basin Faucets")]: "Bathroom",
  [normalizeValue("Bath Faucets")]: "Bathroom",
  [normalizeValue("Shower Faucets")]: "Bathroom",
  [normalizeValue("Bidet Faucets")]: "Bathroom",
  [normalizeValue("Concealed Faucets")]: "Bathroom",
  [normalizeValue("Shower Systems")]: "Bathroom",
  [normalizeValue("Shower Columns")]: "Bathroom",
  [normalizeValue("Shower Heads")]: "Bathroom",
  [normalizeValue("Hand Showers")]: "Bathroom",
  [normalizeValue("Shower Trays")]: "Bathroom",
  [normalizeValue("Shower Enclosures")]: "Bathroom",
  [normalizeValue("Shower Drains")]: "Bathroom",
  [normalizeValue("Shower Rails")]: "Bathroom",
  [normalizeValue("Shower Waste")]: "Bathroom",
  [normalizeValue("Basins")]: "Bathroom",
  [normalizeValue("Basin Waste")]: "Bathroom",
  [normalizeValue("Toilets")]: "Bathroom",
  [normalizeValue("Toilet Seats")]: "Bathroom",
  [normalizeValue("Toilet Paper Holders")]: "Bathroom",
  [normalizeValue("Toilet Frames")]: "Bathroom",
  [normalizeValue("Bidets")]: "Bathroom",
  [normalizeValue("Bathtubs")]: "Bathroom",
  [normalizeValue("Bath Spouts")]: "Bathroom",
  [normalizeValue("Bathroom Accessories")]: "Bathroom",
  [normalizeValue("Towel Rails")]: "Bathroom",
  [normalizeValue("Soap Dishes")]: "Bathroom",
  [normalizeValue("Tumblers")]: "Bathroom",
  [normalizeValue("Toilet Brushes")]: "Bathroom",
  [normalizeValue("Dispensers")]: "Bathroom",
  [normalizeValue("Mirrors")]: "Bathroom",
  [normalizeValue("Bathroom Shelves")]: "Bathroom",
  [normalizeValue("Towel hooks")]: "Bathroom",
  [normalizeValue("Towel Rail")]: "Bathroom",
  [normalizeValue("Bathroom Furniture")]: "Bathroom",
  [normalizeValue("Bathroom Cabinets")]: "Bathroom",
  [normalizeValue("Vanity Units")]: "Bathroom",
  [normalizeValue("Radiator Valves")]: "Bathroom",
  [normalizeValue("WC Flush Buttons")]: "Bathroom",
  [normalizeValue("Bath Screens")]: "Bathroom",
  [normalizeValue("Freestanding bath")]: "Bathroom",
  [normalizeValue("Built-in bath")]: "Bathroom",
  [normalizeValue("Corner / Back to wall bath")]: "Bathroom",
  [normalizeValue("Baths")]: "Bathroom",
};

export function parseProductTags(tags?: string[] | string | null): string[] {
  if (Array.isArray(tags)) {
    return tags
      .flatMap((tag) => String(tag).split(","))
      .map((tag) => tag.trim())
      .filter(Boolean);
  }

  if (typeof tags === "string") {
    return tags
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);
  }

  return [];
}

/**
 * Determines a product's top-level category.
 *
 * Category comes ONLY from the manual assignment:
 *   1. a top-level category tag on the product (set in the admin panel), or
 *   2. as a fallback, the product type (subcategory) that an admin picked.
 *
 * There is deliberately NO guessing from the product title — title based
 * inference caused wrong placements (radiators, TECE modules, mirror lights,
 * filter faucets, Buster + Punch hardware, etc.).
 */
export function inferPrimaryCategoryFromProduct({
  productType = "",
  tags,
}: ProductCategoryInput): TopLevelCategory | undefined {
  const lowerTags = parseProductTags(tags).map(normalizeValue);
  const productTypeLower = normalizeValue(productType);
  const productTypeCategory = PRODUCT_TYPE_TO_CATEGORY[productTypeLower];

  // A precise, known non-bathroom product type overrides stale import tags.
  // This keeps product links and listing filters aligned across the storefront.
  if (productTypeCategory && productTypeCategory !== "Bathroom") {
    return productTypeCategory;
  }

  const taggedCategories = TOP_LEVEL_CATEGORIES.filter((category) =>
    lowerTags.includes(normalizeValue(category))
  );

  if (taggedCategories.length > 0) return taggedCategories[0];

  return productTypeCategory;
}

export function matchesPrimaryCategory(product: ProductCategoryInput, category: string): boolean {
  const categoryLower = normalizeValue(category);
  if (!categoryLower || categoryLower === "all") return true;

  const lowerTags = parseProductTags(product.tags).map(normalizeValue);
  const productTypeCategory = PRODUCT_TYPE_TO_CATEGORY[normalizeValue(product.productType || "")];

  // Imported catalog data can retain a stale top-level tag (for example,
  // switches tagged "Bathroom"). For unambiguous non-bathroom product types,
  // the manually selected product type must win over that stale tag. Bathroom
  // types are intentionally excluded because some supplier feeds use generic
  // bathroom types for more specific manually assigned categories.
  if (
    productTypeCategory &&
    productTypeCategory !== "Bathroom" &&
    normalizeValue(productTypeCategory) !== categoryLower
  ) {
    return false;
  }

  if (
    productTypeCategory &&
    productTypeCategory !== "Bathroom" &&
    normalizeValue(productTypeCategory) === categoryLower
  ) {
    return true;
  }

  // Manual tag assignment always wins.
  if (lowerTags.includes(categoryLower)) return true;

  // If the product carries a different top-level tag, it belongs there only.
  const hasOtherTopLevelTag = TOP_LEVEL_CATEGORIES.some(
    (top) => normalizeValue(top) !== categoryLower && lowerTags.includes(normalizeValue(top))
  );
  if (hasOtherTopLevelTag) return false;

  const inferredCategory = inferPrimaryCategoryFromProduct(product);
  return inferredCategory ? normalizeValue(inferredCategory) === categoryLower : false;
}

export function replaceTopLevelCategoryTags(
  tags: string[] | string | undefined | null,
  desiredCategory: string
): string[] {
  const desired = desiredCategory.trim();
  const desiredLower = normalizeValue(desired);

  const filteredTags = parseProductTags(tags).filter(
    (tag) => !TOP_LEVEL_CATEGORIES.some((category) => normalizeValue(category) === normalizeValue(tag))
  );

  if (!filteredTags.some((tag) => normalizeValue(tag) === desiredLower)) {
    filteredTags.push(desired);
  }

  return filteredTags;
}
